import { useEffect } from 'react';

const ADSENSE_CLIENT_ID = 'ca-pub-7399836737486917';
const ADSENSE_SCRIPT_ID = 'adsense-auto-ads-script';

const AdSenseScript = () => {
  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    const existingScript = document.getElementById(ADSENSE_SCRIPT_ID);
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = ADSENSE_SCRIPT_ID;
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`;
      document.head.appendChild(script);
    }

    return () => {
      const script = document.getElementById(ADSENSE_SCRIPT_ID);
      script?.remove();
    };
  }, []);

  return null;
};

export default AdSenseScript;
